// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../../utils/colors.css\"","red":"#A93E2F","red2":"#B63426","invalid":"ReviewOrder_invalid__2jw5T","terms":"ReviewOrder_terms__3M1PP"};